import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { carsApi } from '../api/cars.js';
import { CarCard } from '../components/cars/CarCard.jsx';

export function CarsList() {
  const [cars, setCars] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    carsApi.list()
      .then((data) => setCars(data.cars))
      .catch((ex) => setErr(ex.body?.error || 'Eroare'));
  }, []);

  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between">
        <h2 className="text-3xl font-semibold tracking-tight text-ink">Mașini</h2>
        <Link to="/cars/new" className="btn-primary hidden md:inline-flex">+ Adaugă</Link>
      </header>

      {err && <div className="rounded-lg border border-danger/30 bg-danger/10 px-3 py-2 text-sm text-danger">{err}</div>}

      {cars === null && <div className="card text-center text-muted">Se încarcă…</div>}

      {cars && cars.length === 0 && (
        <div className="card text-center text-muted">
          <p>Nu există mașini încă.</p>
          <Link to="/cars/new" className="mt-3 btn-primary inline-flex">+ Adaugă prima mașină</Link>
        </div>
      )}

      {cars && cars.length > 0 && (
        <div className="grid gap-3 sm:grid-cols-2">
          {cars.map((c) => <CarCard key={c.id} car={c} />)}
        </div>
      )}
    </div>
  );
}
